/**
 * Website-setup trial mode (/setup/<projectId>?trial=<token>) — visitor from the
 * postcard landing page, no XOFFI account yet. The backend answers most account
 * APIs with 403 {error_code: 'TRIAL_FORBIDDEN', detail: 'not_available_in_trial'};
 * global providers must not call them there (console spam, see 07./08.10.2026).
 */
export function isTrialSession() {
  if (typeof window === 'undefined') return false
  try {
    return window.location.pathname.startsWith('/setup/') &&
      new URLSearchParams(window.location.search).has('trial')
  } catch {
    return false
  }
}

export function isTrialForbidden(err) {
  return err?.status === 403 && (
    err?.payload?.error_code === 'TRIAL_FORBIDDEN' ||
    err?.payload?.detail === 'not_available_in_trial' ||
    err?.message === 'not_available_in_trial'
  )
}
